<script lang="ts">
	import { DefaultLabelFontProps, type FontProps, getFontPropsVarString } from '$types/fontProps'

	type RadioButtonProps = {
		label: string // the label of the RadioButton
		groupName: string // the RadioButton group to which this one belongs, e.g. "priceModality"
		value: string | number | object // the value that is written in selected when selecting another RadioButton in the group
		selected: string | number | object | undefined
		disabled?: boolean
		id?: string | number
		fontProps?: FontProps
	}

	let {
		label,
		groupName,
		value,
		selected = $bindable(),
		disabled = false,
		id = Math.floor(Math.random() * 1000),
		fontProps = DefaultLabelFontProps('15px', 400)
	}: RadioButtonProps = $props()

	const fontPropsVarString = $derived(getFontPropsVarString(fontProps, 'rb'))
</script>

<div class="radio-btn-container">
	<!-- id must not be value, otherwise on clicking the label we select the first of the group and not the clicked -->
	<input
		id={`${groupName}-${id}`}
		type="radio"
		class="radio-btn"
		bind:group={selected}
		name={groupName}
		{value}
		{disabled}
	/>
	<label class="radio-btn-label" for={`${groupName}-${id}`} style={fontPropsVarString}
		>{label}</label
	>
</div>

<style lang="scss">
	@import '$styles/global.scss';

	.radio-btn-container {
		@include flex-row(0.5rem);
	}

	.radio-btn-label {
		@include roboto-font(
			var(--rb-line-height, 15px),
			var(--rb-font-weight, 400),
			var(--rb-font-size, 1rem),
			var(--rb-color, black)
		);

		min-height: 15px;
		height: fit-content;
		max-height: max-content;
	}

	input[type='radio'] {
		appearance: none;
		background-color: $grey-700;
		margin: 0;
		width: var(--rb-size, 20px);
		height: var(--rb-size, 20px);
		border: none;
		border-radius: 50%;
		display: grid;
		place-content: center;
		opacity: 0.5;

		&::before {
			content: '';
			width: var(--rb-checked-size, 12px);
			height: var(--rb-checked-size, 12px);
			border-radius: 50%;
			transform: scale(0);
			transition: 120ms transform ease-in-out;
			box-shadow: inset 1rem 1rem $primaryGreen;
		}

		&:not([disabled]):hover {
			background-color: $grey-775;
		}

		&:checked {
			opacity: 1;

			&::before {
				transform: scale(1);
			}
		}
	}
</style>
